module.exports = new __parcel__URL__("addon.840ab9ef.svg").toString();